import React from 'react'
import { IconProps } from '../../../common/types'

const BulbIcon: React.FC<IconProps> = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.7554 18.2647C25.282 22.2063 22.7004 23.7813 21.5854 24.9247C20.4687 26.0713 20.6687 26.2997 20.7437 27.9813C20.7562 28.1894 20.726 28.3978 20.6549 28.5938C20.5838 28.7897 20.4733 28.969 20.3303 29.1206C20.1873 29.2722 20.0147 29.393 19.8233 29.4754C19.6318 29.5577 19.4255 29.6001 19.217 29.5997H14.787C14.5787 29.5993 14.3727 29.5565 14.1815 29.4739C13.9903 29.3913 13.8179 29.2706 13.6749 29.1191C13.5319 28.9677 13.4212 28.7887 13.3497 28.5931C13.2781 28.3975 13.2472 28.1893 13.2587 27.9813C13.2587 26.3313 13.412 25.948 12.4187 24.9247C11.152 23.658 8.17205 21.8697 8.17205 16.9513C8.16444 15.7297 8.40999 14.5197 8.89323 13.3976C9.37648 12.2756 10.0869 11.2658 10.9798 10.4319C11.8727 9.59808 12.9286 8.95823 14.081 8.55272C15.2335 8.14722 16.4574 7.98484 17.6757 8.07584C18.894 8.16684 20.0802 8.50923 21.1596 9.08144C22.239 9.65364 23.1882 10.4433 23.9473 11.4005C24.7064 12.3577 25.2589 13.4619 25.5701 14.6433C25.8813 15.8246 25.9444 17.0577 25.7554 18.2647Z"
        stroke="#998D8D"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4349 29.508V32.028C14.4349 32.7163 14.8182 33.2813 15.2899 33.2813H18.7116C19.1866 33.2813 19.5682 32.7147 19.5682 32.028V29.508M15.7016 11.9413C14.7175 11.9418 13.7738 12.333 13.0781 13.029C12.3824 13.7251 11.9916 14.6689 11.9916 15.653M29.2216 17.288H32.2782M26.1449 7.268L28.3132 5.09967M27.8116 25.7813L29.9799 27.948M17.0016 1.40967V3.88133M5.7349 5.098L7.88823 7.268M4.06823 27.948L6.22156 25.7813M4.78156 17.288H1.72656"
        stroke="#998D8D"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default BulbIcon
